import { render, staticRenderFns } from "./ChatterProjectList.vue?vue&type=template&id=312dc71c"
import script from "./ChatterProjectList.vue?vue&type=script&lang=js"
export * from "./ChatterProjectList.vue?vue&type=script&lang=js"
import style0 from "./ChatterProjectList.vue?vue&type=style&index=0&id=312dc71c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports